export default __webpack_public_path__ + "icon-arrow-down.png?23b385fcc3c186bda61e2323457f9131";